import axios from 'axios';
import { DispatchSchedule, LegacyShippingSchedule } from 'views/order-feed/types/shipping-schedule.type';

// GET
// /ewosapi/v1/order/dispatch-dates/
export const getDispatchDates = async (marketId: number, customerErpId: string, siteErpId: string): Promise<DispatchSchedule> => {
  const res = await axios.get(`/ewosapi/v1/order/dispatch-dates/`, {
    params: {
      marketId,
      customerErpId,
      siteErpId,
    },
  });
  return res.data;
};

/**
 * @deprecated Use getDispatchDates instead
 * /ewosapi/v2/order/dispatchdates/{market}/{customerNumber}/{siteErpId}
 */
export const getLegacyDispatchDates = async (
  market: number,
  customerNumber: string,
  siteErpId: string,
  includeShippingDatesWithCharge: boolean = false
): Promise<LegacyShippingSchedule> => {
  // if (!isProductionEnvironment && !isStageEnvironment) return DispatchDatesWithScheduleData;

  const res = await axios.get(
    `/ewosapi/v2/order/dispatchdates/${market}/${customerNumber}/${siteErpId}?includeShippingDatesWithCharge=${includeShippingDatesWithCharge}`
  );
  return res.data;
};
